import Highcharts from "../highcharts_config";

export default function renderChart (data) {
  const colors = [
    "#BF153A", // Disasters
    "#DF5B16", // Severe Weather
    "#7724B0", // Terror
    "#D58B10", // Infrastructure
    "#136897", // Health Warnings
  ]

  const chartContainer = document.getElementById("environmental-factors-chart");

  if (!chartContainer) return;

  chartContainer.setAttribute("style", null)

  Highcharts.chart(chartContainer.id, {
    credits: {
      enabled: false,
    },
    chart: {
      type: "column",
    },
    title: {
      text: data.name,
      align: "left",
      margin: 30,
      style: {
        fontWeight: "bold"
      }
    },
    xAxis: {
      categories: data.categories,
      title: {
        text: "Week",
      },
      style: {
        marginTop: 20
      },
    },
    yAxis: {
      min: 0,
      max: 100,
      title: {
        text: "People",
      },
      labels: {
        format: '{value} %'
      },
      stackLabels: {
        enabled: false,
        style: {
          fontWeight: "bold",
          color: ( // theme
              Highcharts.defaultOptions.title.style &&
              Highcharts.defaultOptions.title.style.color
          ) || "gray"
        }
      },
      opposite: true,
      gridLineDashStyle: 'shortdash',
    },
    legend: {
      enabled: false
    },
    tooltip: {
      backgroundColor: "#000",
      borderColor: "#000",
      borderRadius: 15,
      style: {
        color: "#fff",
      },
      headerFormat: "<b>{point.x}</b><br/><br/>",
      pointFormat: "{series.name}: {point.y:,.0f}<br/>Total: {point.stackTotal}",
    },
    plotOptions: {
      column: {
        borderWidth: 1,
        stacking: "percent",
        dataLabels: {
          enabled: false
        }
      }
    },
    series: data.series.map((series,i) => {
      series.color = colors[i]
      series.borderColor = colors[i]
      return series
    })
  })
}
